import React,{useEffect} from 'react'
import Navbar from './Navbar'
import Header from './Header'
import Projects from './Projects'
import Footer from './Footer'
import CTA from './CTA'
const Home = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className=' text-blue-700 overflow-x-hidden'>
        <Navbar/>
       <Header/>
       <Projects/>
       <CTA/>
       <Footer/>
    </div>
  )
}

export default Home